module.exports = __webpack_public_path__ + "img/voter.6193a26d.png";